import { Component, Input, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/shared/services/language.service';
import { statusPipe } from 'src/app/shared/pipes/status.pipe';

@Component({
    selector: 'app-filter-badges',
    templateUrl: './filter-badges.component.html',
    styleUrls: ['./filter-badges.component.scss']
})
export class FilterBadgesComponent implements OnInit {
    @Input() filters: string[] = [];

    filterColors: { [key: number]: string } = {};
    expanded: boolean = false;
    maxVisibleFilters: number = 2; // Mostrar solo 2 filtros por defecto

    private colors = [
        '#f59e0b', // Amber
        '#6366f1', // Indigo
        '#8b5cf6', // Purple
        '#ec4899', // Pink
        '#10b981', // Emerald
        '#3b82f6', // Blue
        '#f97316', // Orange
        '#14b8a6', // Teal
        '#06b6d4', // Cyan
        '#ef4444', // Red
    ];

    ngOnInit(): void {
        // Assign colors to each filter
        this.filters.forEach((filter, index) => {
            this.filterColors[index] = this.colors[index % this.colors.length];
        });


    }

    constructor(public languageService: LanguageService, public statusPipe: statusPipe) { }

    getFilterColor(index: number): string {
        return this.filterColors[index] || this.colors[0];
    }

    get visibleFilters(): string[] {
        return this.expanded ? this.filters : this.filters.slice(0, this.maxVisibleFilters);
    }

    get hasMoreFilters(): boolean {
        return this.filters.length > this.maxVisibleFilters;
    }

    toggleExpand(): void {
        this.expanded = !this.expanded;
    }
}
